const messages = {
  title: "BS Plusi kohta",
  description: "About page description",
};

export default {
  messages,
};
